import {
  attendingColumns,
  waitingColumns,
  completedColumns,
  archivedColumns,
  pendingColumns,
} from './office-visit-table-column';
import moment from 'moment';

const tagsToRemove = ['<p>', '</p>', '<br>'];

export const removeDefTags = (data?: string) => {
  if (data) {
    let val = data;
    tagsToRemove.forEach(tag => {
      val = val.replace(tag, '');
    })
    return val.trim();
  }
  return '';
}

export const getColumns = (name: string) => {
  switch (name) {
    case "pending":
      return pendingColumns;

    case "waiting":
      return waitingColumns;

    case "attending":
      return attendingColumns;

    case "completed":
      return completedColumns;

    case "archived":
      return archivedColumns;

    default:
      return;
  }
}

export function getAssigneeQueryString(assigneeId: string[] | undefined, uncheckedAssignee?: string[]) {
  if (assigneeId === undefined) return undefined;
  if (assigneeId[0] === "all") {
    if (uncheckedAssignee?.length) {
      if (uncheckedAssignee.includes('null')) {
        const filteredVal = uncheckedAssignee.filter(item => item !== "null");
        return (filteredVal.length ? "$not:$in:" + filteredVal?.join(',') + '&' : '') + "$not:$eq:$null";
      }
      return "$not:$in:" + uncheckedAssignee?.join(',') + "&$or:$eq:$null";
    }
    return undefined;
  }
  let queryString;
  const assignees = assigneeId.filter(item => item !== "null");
  if (assignees?.length) {
    queryString = "$in:" + assignees?.join(',');
  }
  if (assigneeId.includes('null')) {
    queryString = queryString ? queryString + "&$or:$eq:$null" : "$eq:$null";
  }
  return queryString;
}

export function getDateQuery(date: [moment.Moment, moment.Moment] | [null, null] | undefined) {
  if (date) {
    const from = moment(date?.[0])?.subtract(1, 'days').format('YYYY-MM-DD');
    const to = moment(date?.[1])?.add(1, 'days').format('YYYY-MM-DD');
    return "$btw:" + from + ',' + to;
  }
  return undefined;
}
